module.exports = __webpack_public_path__ + "media/tsemppiaani2.ba951e6f.wav";